import Reviews from './components/reviews';
import {loadScript} from 'methods/utils';

// плавный прогрессбар
const $bars = document.querySelectorAll('.js-ratingsBar[data-style]').forEach(function($bar) {
    $bar.setAttribute('style', $bar.dataset.style);
});

const $reviews = document.querySelector('.js-reviews');
if ($reviews) {
    new Reviews($reviews);
}

const $vkWidget = document.querySelector('#vk_widget');
if ($vkWidget) {
    loadScript('//vk.com/js/api/openapi.js?120').then(() => {
        function init() {
            const vkGroupId = $vkWidget.dataset.vkGroupId;
            const width = $vkWidget.clientWidth;

            $vkWidget.innerHTML = '<div id="vk_groups"></div>';
            VK.Widgets.Group('vk_groups', {
                mode: 3,
                color2: '37474F',
                width: width,
                no_cover: 1,
            }, vkGroupId);
        }

        window.addEventListener('resize', init);
        init();
    });
}
